import React from "react";

import Lottie from "lottie-react";
import { SupLogo } from "@repo/core-ui";
import superforming from "@/../public/assets/superforming.json";
import { twMerge } from "tailwind-merge";
import Link from "next/link";

export default function UiMessageAtomAnimatedHead() {
  return (
    <div
      className={twMerge(
        "flex h-12 select-none items-center gap-0.5 rounded-tr-[24px] border-0.5",
        "w-48 border-b-0 border-neutral-600 bg-neutral shadow-[5px_5px_10px_#A093E116] lg:opacity-90 lg:hover:opacity-100"
      )}
    >
      <div className="h-max w-16 p-[12px]">
        <Lottie animationData={superforming} loop={true} />
      </div>
      <Link href="https://superformlabs.org" target="_blank" className="lg:hover:opacity-60">
        <SupLogo />
      </Link>
    </div>
  );
}
